// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".small_Service_background_img{\n    width: 100%;\n    position:absolute;\n    max-height: 47px;\n}\n.small_Service_family_site{\n    display: flex;\n    width: 100%;\n}\n.small_Service_div{\n    width: 100%;\n}\n.css-1nrlq1o-MuiFormControl-root{\n    width: 100%;\n}", ""]);
// Exports
module.exports = exports;
